export const TRANSLATION_KEYS = {
    Heading: "settingPage.attributePage.heading",
    SecondaryHeading: "settingPage.attributePage.secondaryHeading",
    TooltipContent: "settingPage.attributePage.tooltipContent",
    TooltipContentTitle: "settingPage.attributePage.tooltipContentTitle",
    ColumnAttributeLabel: "settingPage.attributePage.columnAttributeLabel",
    ColumnAttributeType: "settingPage.attributePage.columnAttributeType",
    ColumnAreaLabel: "settingPage.attributePage.columnAreaLabel",
    ColumnDepartmentLabel: "settingPage.attributePage.columnDepartmentLabel",
    TableEditActions: "settingPage.attributePage.tableEditActions",
    TableEditEdit: "settingPage.attributePage.tableEditEdit",
    TableEditDelete: "settingPage.attributePage.tableEditDelete",
    DeleteDialogHeading: "settingPage.attributePage.deleteDialog.heading",
    DeleteDialogSecondaryHeading: "settingPage.attributePage.deleteDialog.secondaryHeading",
    NewButtonText: "settingPage.attributePage.newProperty",
    DeleteButtonText: "common.deleteText",
    DismissButtonText: "common.dismissText",
    RenderAttribute: "settingPage.attributePage.columnRenderAttributeLabel"
};